import React from 'react';
/**
 * icon-image-enlarge-l
 * icon-image-enlarge
 */
export default ({ rootClassName }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        className={rootClassName}
    >
        <path
            d="M15.815 1.278c-.485.117-.717.726-.432 1.13a.939.939 0 0 0 .277.248c.156.082.219.084 2.338.096l2.178.011-3.404 3.409C14.9 8.046 13.346 9.625 13.318 9.68a.926.926 0 0 0-.051.324c0 .494.414.812.922.708.185-.039.292-.141 3.619-3.464l3.429-3.424.011 2.198.012 2.198.093.149c.36.58 1.228.442 1.365-.218.031-.151.041-1.131.033-3.273-.011-3.013-.012-3.06-.095-3.218a.965.965 0 0 0-.253-.28l-.17-.12-3.146-.006c-1.731-.004-3.203.007-3.272.024M9.9 13.26a2.397 2.397 0 0 1-.16.039c-.09.02-.965.87-3.55 3.453l-3.43 3.427v-2.068c0-1.358-.015-2.138-.044-2.273-.141-.656-1.003-.787-1.363-.207l-.093.149V22.233l.12.17a.965.965 0 0 0 .28.253c.158.083.205.084 3.218.095 2.142.008 3.122-.002 3.273-.033.751-.156.78-1.245.038-1.432-.128-.032-.823-.046-2.276-.046H3.821l3.426-3.43c3.324-3.329 3.426-3.436 3.465-3.621.073-.355-.079-.709-.36-.839-.139-.064-.384-.113-.452-.09"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
